import avatar from '../assets/images/rosana-rodrigues/rosana-rodrigues.jpg';
import audio from '../assets/sounds/rosana-rodrigues.ogg';

import rosana01 from '../assets/images/rosana-rodrigues/RosanaRodrigues_01.jpg';
// import rosana02 from '../assets/images/rosana-rodrigues/RosanaRodrigues_02.jpg';
import rosana02 from '../assets/images/rosana-rodrigues/RosanaRodrigues_03.jpg';
import rosana03 from '../assets/images/rosana-rodrigues/RosanaRodrigues_04.jpg';
import rosana04 from '../assets/images/rosana-rodrigues/RosanaRodrigues_05.jpg';
import rosana05 from '../assets/images/rosana-rodrigues/RosanaRodrigues_06.jpg';
import rosana06 from '../assets/images/rosana-rodrigues/Dia-internacional-das-Mulheres8M-1.jpg';
import rosana07 from '../assets/images/rosana-rodrigues/Dia-internacional-dasMulheres-8M-2.jpg';
import rosana08 from '../assets/images/rosana-rodrigues/Dia-internacional-das-Mulheres-8M-3.jpg';
import rosana09 from '../assets/images/rosana-rodrigues/Dia-internacional-das-Mulheres-8M-4.jpg';
import rosana10 from '../assets/images/rosana-rodrigues/Dia-internacional-de-Luta-das-Mulheres.jpg';
import rosana11 from '../assets/images/rosana-rodrigues/Dia-internacional-de-luta-das-mulheres-8M.jpg';
import rosana12 from '../assets/images/rosana-rodrigues/BlackBloc.jpg';
import rosana13 from '../assets/images/rosana-rodrigues/Bloco_de_carnaval_Carmelitas.jpg';
import rosana14 from '../assets/images/rosana-rodrigues/Detalhe-Musical.jpg';
import rosana15 from '../assets/images/rosana-rodrigues/Ela-e-o-Violo.jpg';
import rosana16 from '../assets/images/rosana-rodrigues/Manifestacao-dos-Professores.jpg';
import rosana17 from '../assets/images/rosana-rodrigues/Marcha-Basta-de-violencia-Outra-Mare-e-possivel.jpg';
import rosana18 from '../assets/images/rosana-rodrigues/Mulheres-Unidas-contra-Bolsonaro-1.jpg';
import rosana19 from '../assets/images/rosana-rodrigues/Mulheres-Unidas-contra-Bolsonaro-2.jpg';
import rosana20 from '../assets/images/rosana-rodrigues/nao-vai-ter-golpe.jpg';
import rosana21 from '../assets/images/rosana-rodrigues/Protesto-dos-professores.jpg';
import rosana22 from '../assets/images/rosana-rodrigues/Bloco_Lemy_Ayò-Bloco_Afro_FEBARJ.jpg';
import rosana23 from '../assets/images/rosana-rodrigues/Amarécomplexo.jpg'




const rosanaData = {
    avatar,
    audio,
    rosana01,
    rosana02,
    rosana03,
    rosana04,
    rosana05,
    rosana06,
    rosana07,
    rosana08,
    rosana09,
    rosana10,
    rosana11,
    rosana12,
    rosana13,
    rosana14,
    rosana15,
    rosana16,
    rosana17,
    rosana18,
    rosana19,
    rosana20,
    rosana21,
    rosana22,
    rosana23
}

export default rosanaData
